import * as icons from '../../assets/icons';
import { type TSvgAssetProps } from '../svgAsset/SvgAsset';

export type TIcons = keyof typeof icons;
export type TIconProps = TSvgAssetProps & {
  name: TIcons;
};

function Icon(props: TIconProps) {
  const { name, className, ...rest } = props;

  const Source = icons[name];

  return <Source className={className} {...rest} />;
}

export { Icon };
